import React from 'react';

import { SVGComponentProps } from './svg.types';

const CustomSelectSvg = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M9.99935 1.66699C5.40768 1.66699 1.66602 5.40866 1.66602 10.0003C1.66602 14.592 5.40768 18.3337 9.99935 18.3337C14.591 18.3337 18.3327 14.592 18.3327 10.0003C18.3327 5.40866 14.591 1.66699 9.99935 1.66699ZM13.3827 9.39199L10.441 12.3337C10.316 12.4587 10.1577 12.517 9.99935 12.517C9.84102 12.517 9.68268 12.4587 9.55768 12.3337L6.61602 9.39199C6.37435 9.15033 6.37435 8.75033 6.61602 8.50866C6.85768 8.26699 7.25768 8.26699 7.49935 8.50866L9.99935 11.0087L12.4993 8.50866C12.741 8.26699 13.141 8.26699 13.3827 8.50866C13.6243 8.75033 13.6243 9.14199 13.3827 9.39199Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default CustomSelectSvg;
